import React, { useState } from "react";
import { FaUpload, FaArrowLeft, FaQrcode, FaExpand } from "react-icons/fa";
import "./easyqr.css";
import UploadReceiptModal from "./UploadReceiptModal";

const JazzCashQR = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [qrExpanded, setQrExpanded] = useState(false);
  const [qrError, setQrError] = useState(false);

  const handleSubmit = (formData) => {
    console.log("Uploaded Receipt Data:", formData);
    // TODO: Backend API Call (Send Data to Server)
  };

  const handleQrError = () => {
    setQrError(true);
  };

  const toggleQrExpand = () => {
    setQrExpanded(!qrExpanded);
  };

  return (
    <div className="epqr-container">
      <div className="epqr-glass-card">
        {/* Header */}
        <div className="epqr-header">
          <button className="epqr-back-btn" onClick={() => window.history.back()}>
            <FaArrowLeft className="icon" /> Back
          </button>
          <div className="epqr-title-section">
            <FaQrcode className="epqr-title-icon" />
            <h1>Jazz Cash QR Payment</h1>
          </div>
          <div className="epqr-security-badge">
            <span className="epqr-secure-icon">🔒</span> SECURE TRANSACTION
          </div>
        </div>

        {/* Content */}
        <div className="epqr-content">
          <p className="epqr-description">
            Scan the QR code below using your Jazz Cash mobile app to complete your payment instantly.
          </p>

          {/* QR Code Section */}
          <div className={`epqr-qr-container ${qrExpanded ? 'expanded' : ''}`}>
            {qrError ? (
              <div className="epqr-error-message">
                <p>Unable to load QR code</p>
                <button 
                  className="epqr-retry-btn"
                  onClick={() => setQrError(false)}
                >
                  Retry
                </button>
              </div>
            ) : (
              <>
                <div className="epqr-qr-wrapper">
                  <img
                    src="./images/WhatsApp Image 2025-05-24 at 3.35.05 PM.jpeg"
                    alt="Jazz Cash QR Code"
                    className="epqr-qr-code"
                    onError={handleQrError}
                  />
                  <button 
                    className="epqr-expand-btn"
                    onClick={toggleQrExpand}
                  >
                    <FaExpand />
                  </button>
                </div>
                <p className="epqr-qr-instruction">
                  Open Jazz Cash App → Tap 'Scan QR' → Scan this code
                </p>
              </>
            )}
          </div>

          {/* Payment Details */}
          <div className="epqr-details">
            <h3>Important Notes:</h3>
            <ul className="epqr-instructions">
              <li>Scan the QR code from your registered Jazz Cash account</li>
              <li>Ensure you're sending the exact amount</li>
              <li>Include your username in payment reference if possible</li>
              <li>Upload receipt immediately after payment</li>
            </ul>
          </div>

          {/* Upload Button */}
          <button 
            className="epqr-upload-btn" 
            onClick={() => setIsModalOpen(true)}
          >
            <FaUpload className="icon" /> Upload Payment Receipt
          </button>
        </div>
      </div>

      {/* Upload Receipt Modal */}
      <UploadReceiptModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSubmit={handleSubmit} 
      />

      {/* QR Expanded Overlay */}
      {qrExpanded && (
        <div className="epqr-expanded-overlay" onClick={toggleQrExpand}>
          <img
            src="./images/WhatsApp Image 2025-05-24 at 3.35.05 PM.jpeg"
            alt="Jazz Cash QR Code (Expanded)"
            className="epqr-expanded-qr"
          />
          <p>Click anywhere to close</p>
        </div>
      )}
    </div>
  );
};

export default JazzCashQR;





